<template>
  <app-content>
    <app-delete-label-dialog
            v-if="deletedItem"
            :item="deletedItem"
            @refreshDeletedItem="refreshDeletedItem"
    />
    <form action="#">
      <div class="inner">
        <p class="buttons">
          <app-button-delete @click="deleteItem(item)" v-if="!newItem" />
        </p>
        <app-content-title v-if="!newItem && !pending && !deleting" :title="item.labelNames[currentLanguageId]" />
        <app-content-title v-if="newItem" :title="translations.newLabel" />
      </div>
      <app-tabs
              :colsTabs="columnTabs"
              :shouldLoadFirstTab="newItem"
              :loadTab="params.tab"
              @appTabChanged="onAppTabChanged"
      >
        <div :title="translations.information">
          <app-settings @submit="onFormSubmit" :disabled="pending">
            <app-settings-content>
              <app-settings-desc :title="translations.basicInfo">
                <p>
                  <translate>Založeno</translate>:<br />
                  <span v-html="formatDateAdvanced(item._created)" />
                </p>
              </app-settings-desc>
              <app-settings-options>

                <app-settings-col class="field_left">
                  <app-settings-select
                          required
                          :error="errors.items.find(el => el.field === 'type')"
                          :label="translations.type"
                  >
                    <app-select
                            :options="enums.labelType"
                            v-model="formItem.type"
                            name="type"
                    />
                  </app-settings-select>
                  <app-input
                          required
                          :label="translations.weight"
                          v-model="formItem.weight"
                          name="weight"
                          type="number"
                          :error="errors.items.find(el => el.field === 'weight')"
                  />

                  <template v-if="!newItem && !deleting">
                    <template v-for="(language, key) in languages">
                      <app-input
                              :key="key"
                              required
                              :label="labelTitleText + ' ' + language.languageName"
                              :error="errors.items.find(el => el.field === 'labelNames' && el.inputField == language._id)"
                              v-model="formItem.labelNames[language._id]"
                              :name="`transObj-labelNames-${language._id}`"
                      />
                    </template>
                  </template>

                  <template v-else class="field_left">
                    <template v-for="(language, key) in languages">
                      <app-input
                              :key="key"
                              required
                              :label="labelTitleText + ' ' + language.languageName"
                              :error="errors.items.find(el => el.field === 'labelNames' && el.inputField == language._id)"
                              :name="`transObj-labelNames-${language._id}`"
                      />
                    </template>
                  </template>
                </app-settings-col>

                <app-settings-col class="field_right">
                  <app-image-input
                          name="defaultPortrait"
                          pClass="field field_poster"
                          :labelTitle="translations.poster"
                          labelClass="poster add_profile_image"
                          :text="translations.uploadPoster"
                          spanClass="sizes"
                          ref="defaultPortrait"
                          :image="watchedItem.defaultPortrait"
                          :imageLink="portraitLink"
                          :disabled="pending"
                          :error="!!errors.first('defaultPortrait')"
                          @fileChanged="onDefaultPortraitChanged"
                  />
                  <app-image-input
                      name="defaultLandscape"
                      pClass="field field_poster"
                      :labelTitle="translations.icon"
                      labelClass="photo add_profile_image"
                      :text="translations.uploadIcon"
                      spanClass="sizes"
                      ref="defaultLandscape"
                      :image="watchedItem.defaultLandscape"
                      :imageLink="landscapeLink"
                      :disabled="pending"
                      :error="!!errors.first('defaultLandscape')"
                      @fileChanged="onDefaultLandscapeChanged"
                  />
                  <app-image-input
                      name="defaultBackgroundLandscape"
                      pClass="field field_poster"
                      :labelTitle="translations.backgroundIcon"
                      labelClass="photo add_profile_image"
                      :text="translations.uploadBackgroundIcon"
                      spanClass="sizes"
                      ref="defaultBackgroundLandscape"
                      :image="watchedItem.defaultBackgroundLandscape"
                      :imageLink="backgroundLandscapeLink"
                      :disabled="pending"
                      :error="!!errors.first('defaultBackgroundLandscape')"
                      @fileChanged="onDefaultBackgroundLandscapeChanged"
                  />
                  <app-image-input
                          name="defaultBig"
                          pClass="field field_poster"
                          :labelTitle="translations.bigIcon"
                          labelClass="icon add_profile_image"
                          :text="translations.uploadBigIcon"
                          spanClass="sizes"
                          ref="defaultBig"
                          :image="watchedItem.defaultBig"
                          :imageLink="bigLandscapeLink"
                          :disabled="pending"
                          :error="!!errors.first('defaultBig')"
                          @fileChanged="onDefaultBigChanged"
                  />
                  <app-image-input
                          name="defaultSmall"
                          pClass="field field_poster"
                          :labelTitle="translations.smallIcon"
                          labelClass="icon add_profile_image"
                          :text="translations.uploadSmallIcon"
                          spanClass="sizes"
                          ref="defaultSmall"
                          :image="watchedItem.defaultSmall"
                          :imageLink="smallLandscapeLink"
                          :disabled="pending"
                          :error="!!errors.first('defaultSmall')"
                          @fileChanged="onDefaultSmallChanged"
                  />
                  <app-image-input
                          name="defaultSvg"
                          pClass="field field_poster"
                          :labelTitle="translations.svgIcon"
                          labelClass="icon add_profile_image"
                          :text="translations.uploadSvgIcon"
                          spanClass="sizes"
                          ref="defaultSvg"
                          :image="watchedItem.defaultSvg"
                          :imageLink="svgLandscapeLink"
                          :disabled="pending"
                          :error="!!errors.first('defaultSvg')"
                          @fileChanged="onDefaultSvgChanged"
                  />
                </app-settings-col>
                <app-settings-col class="field_right">
                  <app-settings-control class="checkbox">
                    <app-checkbox
                        name="showInDashboard"
                        :title="translations.showInDashboard"
                        :disabled="pending"
                        v-model="formItem.showInDashboard"
                    />
                  </app-settings-control>
                  <app-settings-control class="checkbox">
                    <app-checkbox
                        name="showPeriodical"
                        :title="translations.showPeriodical"
                        :disabled="pending"
                        v-model="formItem.showPeriodical"
                    />
                  </app-settings-control>
                </app-settings-col>

              </app-settings-options>
            </app-settings-content>

            <app-settings-buttons :navLinkTitle="translations.list" :nav-link-to="{ name: 'labels' }">
              <app-content-save-button :disabled="pending" @click="disallowBack" />
            </app-settings-buttons>
          </app-settings>
        </div>
        <div
                :title="translations.synonyms + ' (' + (item.synonyms ? item.synonyms.length : 0) + ')'"
                :data-disabled-title="translations.synonymsSaveLabelFirst"
                :data-disabled="!item || !item._id || !item.synonyms"
        >
          <synonyms
                  :item="item"
          />
        </div>
      </app-tabs>
    </form>
  </app-content>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import axios from 'axios'
import { getCommonFormSubmit, setLoadingMessage } from 'utils/form'
import getItemDetailMixin from 'mixins/getItemDetailMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import getLanguagesMixin from 'mixins/getLanguagesMixin'
import { VUE_APP_BASE_API_URL } from 'constants/fileConstants'
import Synonyms from '../../components/Labels/Synonyms'

const itemDetailMixin = getItemDetailMixin({
  apiMethodsSuffix: 'Label',
  enums: true
})

export default {
  name: 'label-item',
  mixins: [
    getLanguagesMixin,
    formatDateMixin,
    itemDetailMixin,
    appTitleMixin()
  ],
  components: {
    Synonyms
  },
  created() {
    this.fetchLanguages()
    this.copyWatchedItem()
    this.defaultPortraitChanged = false
    this.defaultLandscapeChanged = false
    this.defaultBigChanged = false
    this.defaultSmallChanged = false
    this.defaultSvgChanged = false
    this.setDefaultType('LABEL_TYPE_CONTENT')
    this.params.tab = 0
  },
  data() {
    return {
      columnTabs: [
        0,
        1
      ],
      watchedItem: {
        type: null,
        defaultPortrait: null,
        defaultLandscape: null,
        defaultBackgroundLandscape: null,
        labelNames: null
      },
      imagesUploading: false,
      defaultPortraitChanged: false,
      defaultLandscapeChanged: false,
      defaultBackgroundLandscapeChanged: false,
      defaultBigChanged: false,
      defaultSmallChanged: false,
      defaultSvgChanged: false,
      portraitLink: '',
      landscapeLink: '',
      backgroundLandscapeLink: '',
      bigLandscapeLink: '',
      smallLandscapeLink: '',
      svgLandscapeLink: '',
      deletedItem: null
    }
  },
  computed: {
    ...mapState({
      languages: state => state.languages.languages
    }),
    translations() {
      return {
        newLabel: this.$gettext('Nový štítek'),
        basicInfo: this.$gettext('Základní údaje'),
        type: this.$gettext('Typ'),
        weight: this.$gettext('Váha'),
        poster: this.$gettext('Poster'),
        uploadPoster: this.$gettext('Nahrát poster'),
        icon: this.$gettext('Foto'),
        backgroundIcon: this.$gettext('Foto na pozadí'),
        bigIcon: this.$gettext('Velká ikona'),
        smallIcon: this.$gettext('Malá ikona'),
        svgIcon: this.$gettext('SVG ikona'),
        uploadIcon: this.$gettext('Nahrát foto'),
        uploadBackgroundIcon: this.$gettext('Nahrát foto na pozadí'),
        uploadBigIcon: this.$gettext('Nahrát velkou ikonu'),
        uploadSmallIcon: this.$gettext('Nahrát malou ikonu'),
        uploadSvgIcon: this.$gettext('Nahrát SVG ikonu'),
        showInDashboard: this.$gettext('Zobrazit v dashboardu'),
        showPeriodical: this.$gettext('Zobrazovat periodické pořady v koncových aplikacích'),
        list: this.$gettext('Seznam'),
        synonyms: this.$gettext('Synonyma'),
        information: this.$gettext('Informace'),
        synonymsSaveLabelFirst: this.$gettext('Synonyma (nutné uložit štítek)')
      }
    },
    currentTitle() {
      const itemName = this.item.labelNames ? this.item.labelNames[this.currentLanguageId] : this.$gettext('Nový štítek')
      return [
        { name: this.$gettext('Štítky'), link: { name: 'labels' } },
        itemName
      ]
    },
    deleting() {
      if (this.formItem.labelNames) {
        return false
      } else {
        return true
      }
    },
    labelTitleText() {
      return this.$gettext('Název štítku')
    }
  },
  methods: {
    ...mapActions([
      'deleteLabel'
    ]),
    deleteItem(item) {
      this.deletedItem = { ...item }
      this.deletedItem.labelName = this.deletedItem.labelNames[this.currentLanguageId]
    },
    copyWatchedItem() {
      Object.keys(this.watchedItem).forEach(v => (this.watchedItem[v] = this.item[v]))
    },
    refreshDeletedItem() {
      this.deletedItem = null
    },
    async onFormSubmit(e) {
      this.errors.clear()

      this.formErrors = await this.runValidation()
      if (this.formErrors.items.length > 0) {
        this.appShowErrors(this.formErrors.items.map(v => v.msg))
        return
      }

      const commonFormSubmit = getCommonFormSubmit('Label')
      const response = await commonFormSubmit(this, e, { synonyms: (this.item.synonyms) ? this.item.synonyms : [] })
        .catch(err => err.response)
      const labelId = response.data.data._id

      this.handleResponseIfError(response)

      if (!this.backAllowed && response.status === 201) {
        this.goToDetail(response.data.data._id)
      }

      if (this.defaultPortraitChanged || this.defaultLandscapeChanged || this.defaultBigChanged ||
                this.defaultSmallChanged || this.defaultSvgChanged || this.defaultBackgroundLandscapeChanged) {
        try {
          this.setImagesUploading(true)

          const { elements } = e.target
          const imageApiUrl = VUE_APP_BASE_API_URL + 'default-images/'

          if (this.defaultPortraitChanged) {
            const formData = new FormData()
            const filePortrait = elements.namedItem('defaultPortrait').files[0]
            if (filePortrait) {
              formData.set('fileExists', true)
              formData.append('file', filePortrait)
            } else {
              formData.set('fileExist', false)
            }

            formData.append('labelId', labelId)
            formData.append('type', 'IMAGE_TYPE_PORTRAIT')
            formData.append('weight', '0')
            await axios.post(imageApiUrl, formData)
          }

          if (this.defaultLandscapeChanged) {
            const formData = new FormData()
            const fileLandscape = elements.namedItem('defaultLandscape').files[0]
            if (fileLandscape) {
              formData.set('fileExists', true)
              formData.append('file', fileLandscape)
            } else {
              formData.set('fileExists', false)
            }

            formData.append('labelId', labelId)
            formData.append('type', 'IMAGE_TYPE_LANDSCAPE')
            formData.append('weight', '0')
            await axios.post(imageApiUrl, formData)
          }

          if (this.defaultBackgroundLandscapeChanged) {
            const formData = new FormData()
            const fileLandscape = elements.namedItem('defaultBackgroundLandscape').files[0]
            if (fileLandscape) {
              formData.set('fileExists', true)
              formData.append('file', fileLandscape)
            } else {
              formData.set('fileExists', false)
            }

            formData.append('labelId', labelId)
            formData.append('type', 'IMAGE_TYPE_BACKGROUND_LANDSCAPE')
            formData.append('weight', '0')
            await axios.post(imageApiUrl, formData)
          }

          if (this.defaultBigChanged) {
            const formData = new FormData()
            const fileLandscape = elements.namedItem('defaultBig').files[0]
            if (fileLandscape) {
              formData.set('fileExists', true)
              formData.append('file', fileLandscape)
            } else {
              formData.set('fileExists', false)
            }

            formData.append('labelId', labelId)
            formData.append('type', 'IMAGE_TYPE_BIG')
            formData.append('weight', '0')
            await axios.post(imageApiUrl, formData)
          }

          if (this.defaultSmallChanged) {
            const formData = new FormData()
            const fileLandscape = elements.namedItem('defaultSmall').files[0]
            if (fileLandscape) {
              formData.set('fileExists', true)
              formData.append('file', fileLandscape)
            } else {
              formData.set('fileExists', false)
            }

            formData.append('labelId', labelId)
            formData.append('type', 'IMAGE_TYPE_SMALL')
            formData.append('weight', '0')
            await axios.post(imageApiUrl, formData)
          }

          if (this.defaultSvgChanged) {
            const formData = new FormData()
            const fileLandscape = elements.namedItem('defaultSvg').files[0]
            if (fileLandscape) {
              formData.set('fileExists', true)
              formData.append('file', fileLandscape)
            } else {
              formData.set('fileExists', false)
            }

            formData.append('labelId', labelId)
            formData.append('type', 'IMAGE_TYPE_SVG')
            formData.append('weight', '0')
            await axios.post(imageApiUrl, formData)
          }
        } finally {
          this.setImagesUploading(false)
          this.resetDefaultImagesChanged()
        }
      }
    },
    setImagesUploading(uploading) {
      this.imagesUploading = uploading
      setLoadingMessage(this, uploading ? 'Nahrávání obrázků...' : null)
    },
    resetDefaultImagesChanged() {
      this.defaultPortraitChanged = false
      this.defaultLandscapeChanged = false
      this.defaultBigChanged = false
      this.defaultSmallChanged = false
      this.defaultSvgChanged = false
    },
    async runValidation() {
      await this.errors.clear()
      await this.$validator.validateAll()
      return this.errors
    },
    setPortraitLink(value) {
      this.portraitLink = value
    },
    setLandscapeLink(value) {
      this.landscapeLink = value
    },
    onDefaultPortraitChanged() {
      this.defaultPortraitChanged = true
      this.portraitLink = ''
    },
    onDefaultLandscapeChanged() {
      this.defaultLandscapeChanged = true
      this.landscapeLink = ''
    },
    onDefaultBackgroundLandscapeChanged() {
      this.defaultBackgroundLandscapeChanged = true
      this.backgroundLandscapeLink = ''
    },
    onDefaultBigChanged() {
      this.defaultBigChanged = true
      this.bigLandscapeLink = ''
    },
    onDefaultSmallChanged() {
      this.defaultSmallChanged = true
      this.smallLandscapeLink = ''
    },
    onDefaultSvgChanged() {
      this.defaultSvgChanged = true
      this.svgLandscapeLink = ''
    },
    setDefaultType(value) {
      this.formItem.type = value
    }
  },
  watch: {
    item: {
      handler() {
        this.copyWatchedItem()
        if (this.item.defaultImages) {
          if (this.item.defaultImages.IMAGE_TYPE_PORTRAIT) {
            this.portraitLink = this.item.defaultImages.IMAGE_TYPE_PORTRAIT.imageLink
          }
          if (this.item.defaultImages.IMAGE_TYPE_LANDSCAPE) {
            this.landscapeLink = this.item.defaultImages.IMAGE_TYPE_LANDSCAPE.imageLink
          }
          if (this.item.defaultImages.IMAGE_TYPE_BACKGROUND_LANDSCAPE) {
            this.backgroundLandscapeLink = this.item.defaultImages.IMAGE_TYPE_BACKGROUND_LANDSCAPE.imageLink
          }
          if (this.item.defaultImages.IMAGE_TYPE_BIG) {
            this.bigLandscapeLink = this.item.defaultImages.IMAGE_TYPE_BIG.imageLink
          }
          if (this.item.defaultImages.IMAGE_TYPE_SMALL) {
            this.smallLandscapeLink = this.item.defaultImages.IMAGE_TYPE_SMALL.imageLink
          }
          if (this.item.defaultImages.IMAGE_TYPE_SVG) {
            this.svgLandscapeLink = this.item.defaultImages.IMAGE_TYPE_SVG.imageLink
          }
        }
      },
      deep: true
    }
  }
}
</script>
